import createIcon from '../../createIcon';

/**
 * @component @name LegendToggle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTVINFYxM0gyMFYxNVpNMjAgMTdINFYxOUgyMFYxN1pNMTUgMTFMMjAgNy40NVY1TDE1IDguNTVMMTAgNUw0IDguNjZWMTFMOS45MiA3LjM5TDE1IDExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LegendToggle = createIcon('LegendToggle', [
  [
    'path',
    {
      d: 'M20 15H4V13H20V15ZM20 17H4V19H20V17ZM15 11L20 7.45V5L15 8.55L10 5L4 8.66V11L9.92 7.39L15 11Z',
      key: '12aze4',
    },
  ],
]);

export default LegendToggle;
